import { render, staticRenderFns } from "./MenuIconsList.vue?vue&type=template&id=29b134c6&scoped=true"
import script from "./MenuIconsList.vue?vue&type=script&lang=js"
export * from "./MenuIconsList.vue?vue&type=script&lang=js"
import style0 from "./MenuIconsList.vue?vue&type=style&index=0&id=29b134c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b134c6",
  null
  
)

export default component.exports